import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { timeout: { type: Number, default: 5000 } }

  connect() {
    if (this.timeoutValue <= 0) return

    this.timeoutId = window.setTimeout(() => this.dismiss(), this.timeoutValue)
  }

  disconnect() {
    if (this.timeoutId) window.clearTimeout(this.timeoutId)
  }

  close(event) {
    event?.preventDefault()
    this.dismiss()
  }

  dismiss() {
    if (this.dismissed) return

    this.dismissed = true
    this.element.setAttribute("aria-hidden", "true")
    this.element.classList.add("opacity-0", "-translate-y-1")
    window.setTimeout(() => this.element.remove(), 200)
  }
}
